import React from "react";
import {TextInputField, Dialog, Pane, Button, toaster, InlineAlert, Text, EyeOpenIcon, EyeOffIcon} from "evergreen-ui";
import {changeUserPassword} from "../external/actions"
import {connect} from "react-redux";

class ChangePasswordDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            oldPasswordEye: false,
            newPasswordEye: false,
            oldPassword: "",
            isOldPasswordInvalid: false,
            showOldPasswordInvalidMsg: false,
            oldPasswordInvalidMsg: "",
            newPassword: "",
            isNewPasswordInvalid: false,
            showNewPasswordInvalidMsg: false,
            newPasswordInvalidMsg: "",
            confirmPassword: "",
            isConfirmPasswordInvalid: false,
            showConfirmPasswordInvalidMsg: false,
            confirmPasswordInvalidMsg: "",
        };
        this.baseState = this.state
    }

    changePassword = async () => {
        const {
            oldPassword,
            newPassword,
        } = this.state;

        const {
            logout
        } = this.props;

        await this.props.dispatch(changeUserPassword({
            oldPassword,
            newPassword
        }));
        if (this.props.changePasswordData["requestStatus"] === 1) {
            toaster.success("Password changed!", {
                id: "password-change"
            });
            
            logout()
        } else {
            toaster.danger(this.props.changePasswordData.message, {
                id: "password-change"
            })
        }
    };

    validateChangePassword = async () => {

        const {
            oldPassword,
            newPassword,
            confirmPassword,
        } = this.state;

        const {
            showConfirmationDialog
        } = this.props;

        if (oldPassword === "" || newPassword === "" || confirmPassword === "" || newPassword !== confirmPassword) {
            if (oldPassword === "") {
                this.setState({
                    isOldPasswordInvalid: true,
                    oldPasswordInvalidMsg: "Old password is required",
                    showOldPasswordInvalidMsg: true
                });
            }
            if (newPassword === "") {
                this.setState({
                    isNewPasswordInvalid: true,
                    newPasswordInvalidMsg: "New Password is required",
                    showNewPasswordInvalidMsg: true
                });
            }
            if (newPassword !== "" && confirmPassword === "") {
                this.setState({
                    isConfirmPasswordInvalid: true,
                    confirmPasswordInvalidMsg: "Please enter password again",
                    showConfirmPasswordInvalidMsg: true
                });
            }
            if (newPassword.length > 0 && confirmPassword.length > 0 && newPassword !== confirmPassword) {
                this.setState({
                    isConfirmPasswordInvalid: true,
                    confirmPasswordInvalidMsg: "Passwords do not match",
                    showConfirmPasswordInvalidMsg: true
                });
            }
        } else {
            showConfirmationDialog({
                status: true,
                confirmLabel: "Yes",
                cancelLabel: "No",
                intent: "info",
                information: "Are you sure you want to change password",
                action: () => this.changePassword()
            })
        }
    };

    onChangeOfInputFields = async (e, type) => {
        e.persist();
        if (type === "old-password") {
            if (e.target.value.length > 0) {
                await this.setState({
                    oldPassword: e.target.value.toString(),
                    isOldPasswordInvalid: false,
                    showOldPasswordInvalidMsg: false
                });
            } else {
                await this.setState({
                    oldPassword: e.target.value.toString(),
                    isOldPasswordInvalid: true,
                    oldPasswordInvalidMsg: "Old password is required",
                    showOldPasswordInvalidMsg: true
                });
            }
        } else if (type === "new-password") {
            if (e.target.value.length > 0) {
                await this.setState({
                    newPassword: e.target.value.toString(),
                    isNewPasswordInvalid: false,
                    showNewPasswordInvalidMsg: false,
                    isConfirmPasswordInvalid: false,
                    showConfirmPasswordInvalidMsg: false
                });
            } else {
                await this.setState({
                    newPassword: e.target.value.toString(),
                    isNewPasswordInvalid: true,
                    newPasswordInvalidMsg: "New Password is required",
                    showNewPasswordInvalidMsg: true,
                    isConfirmPasswordInvalid: false,
                    showConfirmPasswordInvalidMsg: false
                });
            }
        } else if (type === "confirm-password") {
            if (e.target.value.length > 0) {
                await this.setState({
                    confirmPassword: e.target.value.toString(),
                    isConfirmPasswordInvalid: false,
                    showConfirmPasswordInvalidMsg: false
                });
            } else {
                await this.setState({
                    confirmPassword: e.target.value.toString()
                });
            }
        }
    };

    changePasswordEye = async type => {

        const {
            oldPasswordEye,
            newPasswordEye
        } = this.state;

        if (type === "old-password") {
            await this.setState({oldPasswordEye: !oldPasswordEye});
        } else if (type === "new-password") {
            await this.setState({newPasswordEye: !newPasswordEye});
        }
    };

    onCloseDialog = () => {

        const {
            showDialog
        } = this.props;

        this.setState({
            ...this.baseState
        });
        showDialog(false)
    };

    render() {

        const {
            oldPasswordEye,
            newPasswordEye,
            oldPassword,
            isOldPasswordInvalid,
            showOldPasswordInvalidMsg,
            oldPasswordInvalidMsg,
            newPassword,
            isNewPasswordInvalid,
            showNewPasswordInvalidMsg,
            newPasswordInvalidMsg,
            confirmPassword,
            isConfirmPasswordInvalid,
            showConfirmPasswordInvalidMsg,
            confirmPasswordInvalidMsg
        } = this.state;

        const {
            isShown,
        } = this.props;

        return (

            <Dialog
                isShown={isShown}
                title="Change Password"
                onCloseComplete={() => this.onCloseDialog()}
                hasFooter={false}
            >
                <Pane
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Pane
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        width={"90%"}
                    >
                        <TextInputField
                            width={"90%"}
                            label="Old Password"
                            placeholder="Old Password"
                            type={oldPasswordEye ? "text" : "password"}
                            autoComplete="new-password"
                            value={oldPassword}
                            isInvalid={isOldPasswordInvalid}
                            validationMessage={
                                showOldPasswordInvalidMsg && oldPasswordInvalidMsg
                            }
                            onChange={e => this.onChangeOfInputFields(e, "old-password")}
                        /> 
                        {
                            oldPasswordEye ? 
                                <EyeOpenIcon 
                                    color="muted" 
                                    onClick={() => this.changePasswordEye("old-password")}
                                />
                                :
                                <EyeOffIcon 
                                    color="muted" 
                                    onClick={() => this.changePasswordEye("old-password")}
                                />
                        }
                    </Pane>
                    <TextInputField
                        width={"80%"}
                        alignSelf={"flex-start"}
                        marginLeft={"5%"}
                        label="New Password"
                        placeholder="New Password"
                        type={newPasswordEye ? "text" : "password"}
                        autoComplete="new-password"
                        value={newPassword}
                        isInvalid={isNewPasswordInvalid}
                        validationMessage={
                            showNewPasswordInvalidMsg && newPasswordInvalidMsg
                        }
                        onChange={e => this.onChangeOfInputFields(e, "new-password")}
                    />
                    <Pane
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        width={"90%"}
                    >
                        <TextInputField
                            width={"90%"}
                            label="Confirm Password"
                            placeholder="Confirm Password"
                            type={newPasswordEye ? "text" : "password"}
                            autoComplete="new-password"
                            value={confirmPassword}
                            isInvalid={isConfirmPasswordInvalid}
                            validationMessage={showConfirmPasswordInvalidMsg && confirmPasswordInvalidMsg}
                            onChange={e => this.onChangeOfInputFields(e, "confirm-password")}
                        /> 
                        {
                            newPasswordEye ? 
                                <EyeOpenIcon 
                                    color="muted"
                                    onClick={() => this.changePasswordEye("new-password")}
                                />
                                :
                                <EyeOffIcon 
                                    color="muted"
                                    onClick={() => this.changePasswordEye("new-password")}
                                />
                        }
                    </Pane>
                    <Pane
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        <InlineAlert
                            intent="warning"
                            margin={10}
                            alignSelf={"flex-start"}
                        >
                            <Text size={300}>You will be logged out on password change</Text>
                        </InlineAlert>
                        <Button
                            appearance="primary"
                            margin={"auto"}
                            onClick={() => this.validateChangePassword()}
                        >
                            Change password
                        </Button>
                    </Pane>
                </Pane>
            </Dialog>
        )
    }
}

const mapStateToProps = (
    {
        changePasswordData
    }) => ({
        changePasswordData
    }
);

export default connect(mapStateToProps)(ChangePasswordDialog);
